<template>
	<div class="speech-wrapper">
		<!-- <div class="banner"><img src="@/assets/images/speech.png" alt="" /></div> -->
		<div class="content">
			<div class="main flex-center">
				<div class="introduce-content">开店讲座</div>
				<div class="left">
					<!-- <img src="" alt=""> -->
				</div>
				<div class="right">
					<!-- <img src="" alt=""> -->
				</div>
			</div>
		</div>
		<div class="shop-wrapper ">
			<div class="shop main">
				<div class="shop-left">
					<div class="title">{{ Jzset.title }}</div>
					<div style="white-space: pre-wrap;" class="description">{{ Jzset.detail }}
					</div>
					<div class="info">
						<img src="@/assets/images/item.png" alt="" />
						<div class="info-label">日期</div>
					</div>
					<div class="date">{{ Jzset.date }}</div>
					<div class="info">
						<img src="@/assets/images/clock.png" alt="" />
						<div class="info-label">时间</div>
					</div>
					<div class="time">{{ Jzset.time }}</div>
					<div class="info">
						<img src="@/assets/images/position.png" alt="" />
						<div class="info-label">地点</div>
					</div>
					<div class="address">{{ Jzset.address }}</div>
				</div>
				<div class="shop-right">
					<div v-for="(item, index) in config" :key="index" class="from">
						<div class="label">{{ item.label }}</div>
						<div class="value flex-bt " :class="{ 'error': showError == item.key }">
							<input id="name" v-model="formData[item.key]" :type="item.type"
								:placeholder="item.placeholder" />
							<div v-if="item.type === 'code'" class="code" :class="[item.timer != '60' ? 'disabled' : '']"
								@click="sendCode(item)">{{
									item.buttonText }}</div>
						</div>
					</div>

					<div class="from">
						<div class="label">生意行业</div>
						<select v-model="formData['industry']" :class="{ 'error': showError == 'industry' }"
							class="custom-select">

							<option v-for="opt in options" :value="opt.value" :key="opt.value">{{ opt.label }}
							</option>
						</select>
					</div>
					<div class="from">
						<div class="label">报名场次</div>
						<select v-model="formData['session']" class="custom-select"
							:class="{ 'error': showError == 'session' }">
							<template v-for="option in themes" :value="option.title">
								<option v-if="!option.disabled" :key="option.id">{{ option.title }}
								</option>
							</template>
						</select>
					</div>

					<div class="from">
						<div class="label">您有经营网店或实体店吗？</div>
						<div class="from-radio">
							<div class="radio">
								<input type="radio" v-model="formData['experience']" value="有" />
								<div class="radio-tiele"> 有</div>
							</div>
							<div class="radio">
								<input type="radio" v-model="formData['experience']" value="无" />
								<div class="radio-tiele">没有</div>
							</div>
						</div>
					</div>
					<div key="findex" class="from">
						<div class="label">您的Facebook 专页/ Instagram 名称</div>
						<div class="value flex-bt" :class="{ 'error': showError == 'faceig' }">
							<input id="name" v-model="formData['faceig']" type="text"
								placeholder="您的Facebook 专页/ Instagram 名称" />

						</div>
					</div>
					<!-- 					<div class="from">
						<div class="label">您的Facebook 专页/ Instagram 名称</div>
						<div class="value">
							<input id="faceig" v-model="formData['faceig']"  type="text"
								:class="{ 'error': showError && formData['faceig'] === '' }"
								placeholder="您的Facebook 专页/ Instagram 名称" />
						</div>
					</div> -->
					<div class="pay-attention">* 填妥表格登记，即代表同意所提供之资料可供LOOPSHOP日后作行销用途。</div>
					<div @click='submitForm' class="button">免费报名</div>
				</div>
			</div>
		</div>
		<div class="theme-wrapper">
			<div class="theme">讲座主题</div>
			<div class="case-list main">
				<div class="success-case" v-for="(item, index) in themes" :key="index">
					<div class="date">{{ item.opentime }}</div>
					<div class="title">{{ item.title }}</div>
					<div style="white-space: pre-wrap;" class="process">{{ item.detail }}</div>

					<div @click="selectsession(item)" class="signup" :class="[item.disabled ? 'disabled' : '']">
						{{ item.disabled ? '已结束' : '立即报名' }}</div>
				</div>
			</div>
		</div>
		<SwiperContent></SwiperContent>
		<Start></Start>

		<el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<span>报名成功</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import Start from "@/components/Start.vue"
import SwiperContent from "@/components/SwiperContent.vue"
import { checkFormToast, rules } from 'lonjin-helper'

export default {

	components: { SwiperContent, Start },
	data() {
		return {
			dialogVisible: false,
			Jzset: [],
			caseList: [],
			formData: {
				nickname: '',
				mobile: '',
				email: '',
				industry: '',
				themes: '',
				session: '',
				experience: '',
				faceig: '',
				sjk: 'registration'
			},
			config: [
				{ label: '姓名', placeholder: '请输入姓名', key: 'nickname', type: 'text' },
				{ label: '电话', placeholder: '请输入电话', key: 'mobile', type: 'text' },
				// { label: '电话验证码', placeholder: '电话验证码', key: 'mobileCode', type: 'code', buttonText: '发送验证码', timer: 60 },
				{ label: '邮箱', placeholder: '请输入邮箱', key: 'email', type: 'text' },
				// { label: '邮箱验证码', placeholder: '邮箱验证码', key: 'emailCode', type: 'code', buttonText: '发送验证码', timer: 60 },
			],
			themes: [
			],
			nowthem: {},
			name: '',
			phone: '',
			showError: false,



			options: [
				{ value: '衣服配饰', label: '衣服配饰' },
				{ value: '电子产品', label: '电子产品' },
				{ value: '酒精饮料', label: '酒精饮料' },
				{ value: '珠宝首饰', label: '珠宝首饰' },
				{ value: '急冻食品', label: '急冻食品' },
				{ value: '育儿产品', label: '育儿产品' },
				{ value: '护肤彩妆', label: '护肤彩妆' },
				{ value: '烘培零食', label: '烘培零食' },
				{ value: '宠物用品', label: '宠物用品' },
				{ value: '运动用品', label: '运动用品' },
				{ value: '玩具书籍', label: '玩具书籍' },
				{ value: '手作产品', label: '手作产品' },
				{ value: '珍馐佳肴', label: '珍馐佳肴' },
				{ value: '其他', label: '其他' },
			],
			selectedOption: '', // 存储选择的选项值
			selectedRadio: null
		};
	},
	mounted() {

		this.getList()
		this.getJzSet()
		// this.getCaseList()
	},
	methods: {
		selectsession(item) {
			if (!item.disabled) {
				this.nowthem = item
				this.formData['session'] = item.title
				window.scrollTo({
					top: 300,
					behavior: 'smooth' // Optional: Adds smooth scrolling animation
				});
			}
		},

		handleClose() {
			this.dialogVisible = !this.dialogVisible
		},


		sendCode(val) {
			if (val.buttonText != '发送验证码') return false;
			this.config.map(item => {
				val.key === item.key && (item.timer = 59)
			})
			let timer = setInterval(() => {
				this.config.map(item => {
					if (item.timer != 60) {
						item.timer--
						if (item.timer <= 0) {
							clearInterval(timer)
							item.buttonText = '发送验证码'
							item.timer = 60
						} else {
							item.buttonText = `${item.timer}S`
						}
					}
				})
			}, 1000)
		},

		isFutureDate(dateString) {
			const currentDate = new Date();
			const inputDate = new Date(dateString);
			return inputDate > currentDate;
		},

		async submitForm() {
			this.showError = '';
			const mobileRules = (val, message) => {
				const reg = /^\d{8}$/;
				if (!reg.test(val)) return message
			}
			let nickname = rules.isEmpty(this.formData.nickname, '请输入姓名')
			let mobile = rules.isEmpty(this.formData.mobile, '请输入电话')
			let isMobile = mobileRules(this.formData.mobile, '请输入8位电话号码')
			let email = rules.isEmpty(this.formData.email, '请输入邮箱')
			let isEmail = rules.isEmail(this.formData.email, '请输入正确的电邮')
			let industry = rules.isEmpty(this.formData.industry, '请选择生意行业')
			let session = rules.isEmpty(this.formData.session, '请选择报名场次')
			let experience = rules.isEmpty(this.formData.experience, '请选择您有经营网店或实体店')
			let faceig = rules.isEmpty(this.formData.faceig, '请输入您的Facebook 专页/ Instagram 名称')

			const MESSAGE_ENUM = {
				'请输入姓名': 'nickname',
				'请输入电话': 'mobile',
				'请输入8位电话号码': 'mobile',
				'请输入邮箱': 'email',
				'请输入正确的电邮': 'email',
				'请选择生意行业': 'industry',
				'请选择报名场次': 'session',
				'请选择您有经营网店或实体店': 'experience',
				'请输入您的Facebook 专页/ Instagram 名称': 'faceig',
			}

			let result = checkFormToast(nickname, mobile, isMobile, email, isEmail, industry, session, experience, faceig)


			if (result) {
				this.showError = MESSAGE_ENUM[result]
				this.$message.error(result)
			} else {
				// 执行报名逻辑
				console.log('报名成功');
				let res = await this.$api.register(this.formData)
				if (res.code == 1) {
					this.dialogVisible = true
				} else {
					this.$message.error('error');
				}

			}
		},
		async getList() {
			this.showMoreBtn = false
			let fdata = { do: 'json', sjk: 'speechlist', orderby: 'orderid asc', limit: 10 }
			let res = await this.$api.funk(fdata)
			res.forEach(i => {
				i.disabled = !this.isFutureDate(i.opentime)
			})
			console.log('res', res);
			this.themes = res
			this.nowthem = res[0]
		},
		async getCaseList() {
			let fdata = { do: 'json', sjk: 'caselist', orderby: 'orderid asc' }
			let res = await this.$api.funk(fdata)
			this.caseList = res
		},

		async getJzSet() {
			let fdata = { do: 'getset', goto: 'jiangzuoset', orderby: 'orderid asc' }
			let res = await this.$api.funk(fdata)
			this.Jzset = res
		},

	}
};
</script>
<style lang="scss" scoped>
.speech-wrapper {
	.banner {
		width: 100%;
		display: block;

		img {
			width: 100%;
			display: block;
		}
	}

	.content {
		width: 100%;
		height: 4.2rem;
		background: url('~@/assets/images/banner/speech.png')no-repeat center center /100% 100%;
		position: relative;
		background-size: cover;

		.main {
			height: 100%;
		}

		.left {
			width: 4.53rem;
			position: absolute;
			top: 0;
			left: 0;
			height: 100%;

			img {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: cover;
			}
		}

		.right {
			width: 4.53rem;
			position: absolute;
			top: 0;
			right: 0;
			height: 100%;

			img {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: cover;
			}
		}

		.introduce-content {
			font-family: 'Microsoft YaHei';
			font-style: normal;
			font-weight: 600;
			font-size: 0.64rem;
			line-height: 0.64rem;
			color: #000000;
			text-align: center;

			span {
				color: #E02E43;
			}
		}

		.tips {
			font-family: 'Microsoft YaHei';
			font-style: normal;
			font-weight: 400;
			font-size: 0.24rem;
			line-height: 0.34rem;
			text-align: center;
			color: #000000;
			margin-top: 0.16rem;
		}
	}

	.shop-wrapper {
		background: url('~@/assets/images/commerceClassroom-bgs.png')no-repeat center center /100% 100%;

		.shop {
			display: flex;
			justify-content: space-between;

			.shop-left {
				.title {
					font-family: 'Microsoft YaHei';
					font-style: normal;
					font-weight: 600;
					font-size: 0.8rem;
					line-height: 1.12rem;
					color: #000000;
					padding: 1.26rem 0 0.51rem 0rem;
				}

				.description {
					font-family: 'Microsoft YaHei';
					font-style: normal;
					font-weight: 400;
					font-size: 0.32rem;
					line-height: 0.45rem;
					color: #000000;
					width: 6.20rem;

				}

				.date {
					font-family: 'Microsoft YaHei';
					font-style: normal;
					font-weight: 600;
					font-size: 0.24rem;
					line-height: 0.34rem;
					color: #000000;
				}

				.time {
					font-family: 'Microsoft YaHei';
					font-style: normal;
					font-weight: 600;
					font-size: 0.24rem;
					line-height: 0.34rem;
					color: #000000;
				}
				.address {
					font-family: 'Microsoft YaHei';
					font-style: normal;
					font-weight: 600;
					font-size: 0.24rem;
					line-height: 0.34rem;
					color: #000000;
				}

				.info {
					display: flex;
					align-items: center;
					margin-top: 0.4rem;

					// margin-bottom: ;
					img {
						height: 0.26rem;
					}

					.info-label {
						font-family: 'Microsoft YaHei';
						font-style: normal;
						font-weight: 400;
						font-size: 0.2rem;
						padding-left: 0.12rem;
						color: #E02E43;
					}
				}
			}

			.shop-right {
				width: 5.1rem;
				background: #FFFFFF;
				border: 1px solid #999999;
				border-radius: 0.08rem;
				padding: 0.4rem;
				margin-bottom: 0.41rem;
				margin-top: 0.8rem;

				.pay-attention {
					font-family: 'Microsoft YaHei';
					font-style: normal;
					font-weight: 400;
					font-size: 0.12rem;
					line-height: 0.17rem;
					/* identical to box height */


					color: #000000;
				}



				input {
					padding: 0 0.16rem;
				}

				.button {
					width: 2.56rem;
					font-family: 'Microsoft YaHei';
					font-style: normal;
					font-weight: 600;
					font-size: 0.24rem;
					line-height: 0.64rem;
					color: #FFFFFF;
					text-align: center;
					background: #E02E43;
					border-radius: 0.08rem;
					margin: auto;
					margin-top: 0.40rem;
					cursor: pointer;
				}

				.from {
					margin-bottom: 0.16rem;



					.from-radio {
						display: flex;

						.radio {
							display: flex;
							align-items: center;
							margin-top: 0.08rem;

							input {
								width: 0.16rem;
								height: 0.16rem;
								left: 0px;
								top: 0.06rem;
								background: #D9D9D9;
								border: 1px solid #000000;
								display: block;
							}

							.radio-tiele {
								font-family: 'Microsoft YaHei';
								font-style: normal;
								font-weight: 400;
								font-size: 0.2rem;
								line-height: 0.28rem;
								color: #000000;
							}

							input[type="radio"]:checked {
								color: black;
							}
						}

					}

					.label {
						font-family: 'Microsoft YaHei';
						font-style: normal;
						font-weight: 400;
						font-size: 0.20rem;
						line-height: 0.28rem;
						color: #000000;
						margin-bottom: 0.08rem;
					}



					.value {
						width: 4.30rem;
						height: 0.56rem;
						background: #FAFAFA;
						border: 1px solid #999999;
						border-radius: 0.08rem;
						overflow: hidden;

						input {
							flex: 1;
							height: 100%;
						}

						.code {
							background: #e02e43;
							color: #fff;
							width: 1rem;
							height: 0.46rem;
							font-size: 12px;
							text-align: center;
							border-radius: 0.08rem;
							line-height: 0.46rem;
							cursor: pointer;
							margin-right: 0.04rem;

							&.disabled {
								background: #999999;
								cursor: not-allowed;
							}
						}
					}

					select {
						padding: 0 0.16rem;
					}

					input::placeholder {
						font-family: 'Nunito';
						font-style: normal;
						font-weight: 400;
						font-size: 0.16rem;
						line-height: 0.24rem;
						letter-spacing: 0.5px;
						color: #1C1B1F;
					}

					.custom-select {
						display: block;
						width: 100%;
						background: #FFFFFF;
						border: 1px solid #999999;
						border-radius: 0.08rem;
						height: 0.56rem;
					}

					.custom-select option {
						color: red;
						font-size: 0.16rem;
						line-height: 0.24rem;
					}

					.custom-select::placeholder {
						font-family: 'Nunito';
						font-style: normal;
						font-weight: 400;
						font-size: 0.16rem;
						line-height: 0.24rem;
						letter-spacing: 0.5px;
						color: #1C1B1F;

					}
				}



				.error {
					border: 1px solid red !important;
				}

			}


		}
	}

	.theme-wrapper {
		background: #e02e43;
		padding: 1.04rem 0;

		.theme {
			font-family: "Microsoft YaHei";
			font-style: normal;
			font-weight: 600;
			font-size: 0.4rem;
			line-height: 0.56rem;
			margin-bottom: 0.6rem;
			text-align: center;
			color: #ffffff;
		}

		.case-list {
			display: flex;
			flex-wrap: wrap;

			.success-case {
				background: #ffffff;
				border-radius: 0.24rem;
				width: 4rem;
				height: 4.31rem;
				margin-left: 0.4rem;
				margin-bottom: 0.4rem;
				padding: 0.32rem;

				.date {
					font-family: "Microsoft YaHei";
					font-style: normal;
					font-weight: 500;
					font-size: 0.16rem;
					line-height: 0.22rem;

					color: #000000;
				}

				.title {
					font-family: "Microsoft YaHei";
					font-style: normal;
					font-weight: 500;
					font-size: 0.32rem;
					line-height: 0.45rem;
					color: #e02e43;
				}

				.process {
					font-family: "Microsoft YaHei";
					font-style: normal;
					font-weight: 400;
					font-size: 0.24rem;
					line-height: 0.34rem;
					color: #000000;
					margin-top: 0.12rem;
					overflow: hidden;
					text-overflow: ellipsis;
					-webkit-line-clamp: 5;
					display: -webkit-box;
					min-height: 1.8rem;
					-webkit-box-orient: vertical;
				}

				.signup {
					background: #e02e43;
					border-radius: 0.08rem;
					font-family: "Microsoft YaHei";
					font-style: normal;
					font-weight: 600;
					font-size: 0.24rem;
					line-height: 0.32rem;
					color: #ffffff;
					padding: 0.16rem;
					width: 2.56rem;
					margin: 0 auto;
					margin-top: 0.32rem;
					text-align: center;
					cursor: pointer;

					&.disabled {
						cursor: inherit;
						background: #9f9899;
					}
				}
			}

			.success-case:first-child {
				margin-left: 0rem;
			}

			.success-case:nth-child(4) {
				margin-left: 0rem;
			}
		}
	}
}

@media (max-width: 750px) {
	.speech-wrapper .shop-wrapper .shop {
		display: block;
	}

	.speech-wrapper .shop-wrapper .shop .shop-left .description {
		width: 100%;
	}

	.speech-wrapper .shop-wrapper .shop .shop-left .info .info-label {
		font-size: 0.28rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-left .info img {
		height: 0.3rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-left .date {
		font-size: 0.28rem;
		line-height: 0.28rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right {
		background: #FFFFFF;
		box-shadow: 0px 0.08rem 0.16rem rgba(0, 0, 0, 0.25);
		border-radius: 0.32rem;
		width: 100%;
		border: none;
		height: auto;
		margin-bottom: 0;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .from input {
		width: 100%;
		height: 0.8rem;
		font-size: 0.28rem;
	}

	.speech-wrapper .shop-wrapper {
		padding-bottom: 0.8rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .from {
		margin-bottom: 0.32rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .from .custom-select {
		width: 100%;
		height: 0.8rem;
		position: relative;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .from .label {
		font-size: 0.28rem;
		line-height: 0.28rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .from .from-radio .radio .radio-tiele {
		font-size: 0.24rem;
		line-height: 0.24rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .from .from-radio .radio input {
		width: 0.28rem;
		height: 0.28rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .pay-attention {
		line-height: 0.3rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .button {
		cursor: pointer;
		width: 4rem;
		line-height: 1rem;
		border-radius: 0.2rem;
	}

	.speech-wrapper .shop-wrapper {
		background: url('~@/assets/images/commerceClassroom-mobile.png')no-repeat center center /100% 100%;
	}

	.speech-wrapper .theme-wrapper .case-list {
		display: block;
		padding: 0 0.8rem;
	}

	.speech-wrapper .theme-wrapper .case-list .success-case {
		width: 100%;
		margin: 0;
		margin-bottom: 0.4rem;
		padding: 0.4rem;
		height: auto;
	}

	.speech-wrapper .theme-wrapper .case-list .success-case .date {
		font-size: 0.24rem;
		line-height: 0.24rem;
		margin-bottom: 0.2rem;
	}

	.speech-wrapper .theme-wrapper .case-list .success-case .process {
		font-size: 0.28rem;
		line-height: 0.32rem;
	}

	.speech-wrapper .theme-wrapper .theme {
		font-size: 0.6rem;
		line-height: 0.6rem;
	}

	.content .left,
	.content .right {
		display: none;
	}
}
</style>